import React, {Component, forwardRef} from "react";
import i18next from "i18next";
import ReactDOM from "react-dom";
import "../../style/ComponentsStyle.css";
import DatePicker, {setDefaultLocale, registerLocale} from "react-datepicker";
import {formatISO, isValid, parse, parseISO, isToday} from "date-fns"
import {ru, enUS, uk} from "date-fns/locale";
import InputMask from "react-input-mask";
import PropTypes from "prop-types";

const DateInputField = forwardRef((props, ref) => {
    const formatChars = {
        "9": "[0-9]",
        "0": "[0-9\\s]",
        "C": "[A-Za-zА-Яа-я]",
        "c": "[A-Za-zА-Яа-я\\s]",
        "A": "[A-Za-zА-Яа-я0-9]",
        "a": "[A-Za-zА-Яа-я0-9\\s]",
        "?": ".",
        "@": "[^!\\s]",
        "d": "[0-3]",
        "f": "[0-1]"
    }
    const resetClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        props.onChange(e);
    }
    return (
        <div className="input-group datePicker" onClick={props.onClick}>
            <InputMask maskChar={null}
                       //maskChar={"_"}
                       mask={"d9.f9.9999"}
                       alwaysShowMask={false}
                       formatChars={formatChars}
                       {...props}
            />
            {props.showResetDateButton && <div onClick={resetClick}><span className="clear zmdi zmdi-close"/></div>}
            {props.showCalendarButton && <div className="input-group-append">
                <button className="btn" type="button"><i className="zmdi zmdi-calendar"/></button>
            </div>}
        </div>);
});

class MnDatePicker extends Component {
    dateFormat = "dd.MM.yyyy";

    constructor(props, context) {
        //console.log(`constructor props.value=[${props.value}]`);
        super(props, context);
        this.el = document.createElement('div');
        this.modalRoot = document.getElementById('modal-root');
        //this.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        registerLocale("ru", ru);
        registerLocale("uk", uk);
        registerLocale("en", enUS);
        setDefaultLocale(i18next.language);
    }
    componentDidMount() {
        this.modalRoot.appendChild(this.el);
    }

    componentWillUnmount() {
        this.modalRoot.removeChild(this.el);
    }

    getFormattedDate = (value) => {
        return value.format("yyyy-MM-ddTHH:mm:ss.SSS");
    };

    onChangeDate = (value) => {
        // if (this.props.value && (value === null || value === "" || value === undefined))
        //     this.props.onChange(null);
        // else {
        //     if(isValid(value)) {
        //         //const date = zonedTimeToUtc(value, this.timeZone);
        //         const formattedValue = formatISO(value, {representation: "date"});
        //         this.props.onChange(formattedValue);
        //     }
        // }
        const toDateSafe = (v) => {
            if (!v) return null;
            if (v instanceof Date) return v;
            if (typeof v === "string") {
                try {
                    return parseISO(v);
                } catch {
                    return null;
                }
            }
            if (typeof v?.format === "function") {
                try {
                    const s = v.format("YYYY-MM-DD");
                    return parseISO(s);
                } catch {
                    return null;
                }
            }
            return null;
        };
        if (value == null || value === "" || value === undefined) {
            const curr = toDateSafe(this.props.value);
            if (curr && isValid(curr) && isToday(curr)) {
                return;
            }
            this.props.onChange(null);
            return;
        }

        if (isValid(value)) {
            const formattedValue = formatISO(value, {representation: "date"});
            this.props.onChange(formattedValue);
        }
    }
/*
    onChangeRaw = (e) => {
        if (e.target.value === null || e.target.value === "" || e.target.value === undefined) {
            this.onChangeDate(null);
        }
    }
*/
    calendarContainer = ({children}) => {
        return ReactDOM.createPortal(
            children,
            this.el
        );
    };
    onKeyDown = (e) =>{
        if(e.key === 'Tab') {
            if (this.datepickerRef) {
                this.datepickerRef.setOpen(false);
            }
        }
    }

    render() {
        //console.log(`render props.value=[${this.props.value}]`);
        let date = null;

        if (typeof this.props.value === "string") {
            date = this.props.value ? parseISO(this.props.value) : null;
        } else if (typeof this.props.value?.format === "function") {
            date = this.props.value.format("YYYY-MM-DDTHH:mm:ss");
            date = date ? parseISO(date) : null;
        }

        return (
            <div>
                <DatePicker
                    ref={(r) => this.datepickerRef = r}
                    selected={date}
                    onChange={this.onChangeDate}
                    className="form-control"
                    showYearDropdown={true}
                    readOnly={this.props.readOnly}
                    disabled={this.props.readOnly}
                    disabledKeyboardNavigation={true}
//                    onChangeRaw={this.onChangeRaw}
                    customInput={<DateInputField showResetDateButton={this.props.showResetDateButton} showCalendarButton={this.props.showCalendarButton}/>}
                    popperClassName="mn_datePicker_popper"
                    popperContainer={this.calendarContainer}
                    todayButton={i18next.t("Today")}
                    locale={i18next.language}
                    dateFormat={this.dateFormat}
                    onKeyDown={this.onKeyDown}
                    excludeDateIntervals={this.props.excludeDateIntervals}
                />
            </div>
        );
    }
}

DateInputField.propTypes = {
    showResetDateButton: PropTypes.bool,
    showCalendarButton: PropTypes.bool
};

DateInputField.defaultProps = {
    showResetDateButton: true,
    showCalendarButton: true
};

MnDatePicker.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    showResetDateButton: PropTypes.bool,
    showCalendarButton: PropTypes.bool,
    excludeDateIntervals: PropTypes.array
};

MnDatePicker.defaultProps = {
    showResetDateButton: true,
    showCalendarButton: true,
    onChange: () => {
    }
};

export default MnDatePicker;